import React, { createContext, useContext, useEffect } from "react";
import { Modal, Select, Form, notification, Divider, Spin } from "antd";
import WrfmSettingStore from "../../store/wrfmsettingstore";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";

const wrfmStoreCtx = createContext(WrfmSettingStore);
const { Option } = Select;
export const MappingDialog = observer(() => {
  const wrfmStore = useContext(wrfmStoreCtx);

  useEffect(() => {
    async function loadFlowStations() {
      try {
        await wrfmStore.loadFlowStations();
        await wrfmStore.loadFields();
      } catch (error) {
        notification.error({
          message: "Feedback Manager",

          description: `Something went wrong.${error.message}.`,
        });
      }
    }
    loadFlowStations();
  }, []);

  return (
    <Modal
      visible={wrfmStore.showMappingDialog}
      onCancel={() => {
        wrfmStore.showMappingDialog = false;
      }}
      width={400}
      centered
      destroyOnClose={true}
      title={`${wrfmStore.action}  Field to Flowstation Mapping`}
      onOk={async () => {
        try {
          const retVal = await wrfmStore.createMapping();
          wrfmStore.flowstationfields.set(retVal.flowstationFieldId, retVal);
          notification.success({
            message: "Feedback Manager",

            description: `mapping successfully created`,
          });
          wrfmStore.showMappingDialog = false;
        } catch (error) {
          notification.error({
            message: "Feedback Manager",

            description: `Something went wrong.${error.response.text}.`,
          });
        }
      }}
      okText={`${wrfmStore.action} Mapping`}
      okButtonProps={{
        disabled: !(
          toJS(wrfmStore.selMapping)?.fieldName &&
          toJS(wrfmStore.selMapping)?.flowstationName
        ),
        loading: wrfmStore.isSaving,
      }}
    >
      <Spin spinning={wrfmStore.isLoading} tip="Loading form data...">
        <Form layout="vertical">
        <Form.Item label="Flowstation" required>
          <Select
            showSearch
            style={{ width: "80%" }}
            placeholder="Select Flowstation"
            optionFilterProp="children"
            value={toJS(wrfmStore.selMapping)?.flowstationId}
            onChange={(value, selItem) => {
              try {
                wrfmStore.selMapping = {
                  ...wrfmStore.selMapping,
                  flowstationId: value,
                  flowstationName: selItem.children,
                };
                console.log(toJS(wrfmStore.selMapping));
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: `hirerachy loading failed`,
                });
              }

              // console.log(value)
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {[...wrfmStore.flowstations.values()]
              .map((f) => toJS(f))
              .map((f) => (
                <Option value={f.flowstationId} key={f.flowstationName}>
                  {f.flowstationName} ({f.status})
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item label="Field" required>
          <Select
            showSearch
            style={{ width: "80%" }}
            placeholder="Select Field"
            optionFilterProp="children"
            value={toJS(wrfmStore.selMapping)?.fieldId}
            onChange={(value, selItem) => {
              try {
                wrfmStore.selMapping = {
                  ...wrfmStore.selMapping,
                  fieldId: value,
                  fieldName: selItem.children,
                };
                console.log(toJS(wrfmStore.selMapping));
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: `hirerachy loading failed`,
                });
              }

              // console.log(value)
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {[...wrfmStore.fields.values()]
              .map((f) => toJS(f))
              .map((f) => (
                <Option value={f.fieldId} key={f.fieldName}>
                  {f.fieldName} ({f.status})
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Divider>Mapping Preview</Divider>
        {toJS(wrfmStore.selMapping)?.fieldName &&
          toJS(wrfmStore.selMapping)?.flowstationName && (
            <span style={{ color: "red" }}>
              Map {toJS(wrfmStore.selMapping).fieldName} Field to{" "}
              {toJS(wrfmStore.selMapping).flowstationName} Flowstation
            </span>
          )}
        </Form>
      </Spin>
    </Modal>
  );
});

